module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/assets/document/log-file-format.png
// module id = oToC
// module chunks = 4